// Funciones comunes para trabajar con enums

export const getItem = (options, key, prop) => {
    const item = options.find(option => option.value === key);
    if (prop && item) return item[prop];
    return item;
};

export const filterValues = (options, values) => {
    return options.filter(option => values.includes(option.value));
};

// Importa y reexporta todos los enums

// Refactorizados (con constantes)
export * from './campañas';
export * from './ejercicios';
export * from './scopes';
export * from './changeLogs';
export * from './contactType';
export * from './locksParcel';
export * from './incidenceParcel';
export * from './statesAsset';
export * from './statesEntity';
export * from './statesExecution';
export * from './statesResolution';
export * from './statesLiquidation';
export * from './resultsResolution';
export * from './usesForm';
export * from './statesTask';
export * from './validationsTask';
export * from './representationRol';
export * from './useParcel';
export * from './authDocument';
export * from './authAction';
export * from './typeQuota';
export * from './statesArqueta';
export * from './typeRepresentative';
export * from './tipos-operacion-venta';

// Pendientes de refactorizar (sin constantes)
export * from './prioridades';
export * from './archivo';
export * from './censos';
export * from './tiposEmpresa';
export * from './sistemasExplotacion';
export * from './tiposExpedicion';
export * from './tiposVino';
export * from './tipoEnvase';
export * from './tipoHomologacion';
export * from './tipos-gasto';
export * from './tiposPago';
export * from './mediosPago';
export * from './unidadVencimientos';
export * from './ajusteVencimientos';
export * from './tipoPartida';
export * from './tiposDocumento';
export * from './tiposApunte';
export * from './sector';
export * from './tipoSocio';
export * from './claseTramite';
